export const COOKIE_CONSENT_VERSION = 1
export const COOKIE_CONSENT_STORAGE_KEY = "slmath-cookie-consent"
export const COOKIE_CONSENT_EVENT = "slmath:cookie-consent-changed"

export const DEFAULT_COOKIE_PREFERENCES = Object.freeze({
	analytics: false,
	embeddedMedia: false,
})

const normalizePreferences = (preferences = {}) => ({
	analytics: preferences.analytics === true,
	embeddedMedia: preferences.embeddedMedia === true,
})

export const readCookieConsent = () => {
	try {
		const rawConsent = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
		if (!rawConsent) return null

		const consent = JSON.parse(rawConsent)
		if (consent.version !== COOKIE_CONSENT_VERSION || !consent.preferences) return null

		return {
			version: COOKIE_CONSENT_VERSION,
			decidedAt: consent.decidedAt,
			preferences: normalizePreferences(consent.preferences),
		}
	} catch (_error) {
		return null
	}
}

export const getCookiePreferences = () => {
	const consent = readCookieConsent()
	return consent ? consent.preferences : { ...DEFAULT_COOKIE_PREFERENCES }
}

export const saveCookieConsent = (preferences) => {
	const consent = {
		version: COOKIE_CONSENT_VERSION,
		decidedAt: new Date().toISOString(),
		preferences: normalizePreferences(preferences),
	}

	try {
		window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(consent))
	} catch (_error) {
		// The in-memory event still applies the visitor's choice for this page view.
	}

	window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: consent }))
	return consent
}
